import type { ReactNode } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

/** Provider return values identify a status view; they never prove payment. */
export function TournamentCheckoutReturn({
  children,
}: {
  children: ReactNode;
}) {
  const [params] = useSearchParams();
  const checkoutId = params.get("registration_checkout_id");
  const outcome = params.get("checkout");
  if (checkoutId && (outcome === "success" || outcome === "cancel")) {
    return (
      <Navigate
        replace
        to={`/compete/mine?type=tournament&payment_id=${encodeURIComponent(checkoutId)}`}
      />
    );
  }
  return children;
}
